// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3PPky","title":"BackImages_title__2AxMd","images":"BackImages_images__1SpX5"};